/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IPregnancyCase } from 'app/shared/model/pregnancy-case.model';
import { IDoctor } from 'app/shared/model/doctor.model';
import { IHospital } from 'app/shared/model/hospital.model';
import { IVitals } from 'app/shared/model/vitals.model';
import { IGlucoUser } from 'app/shared/model/gluco-user.model';
import { Gestation } from 'app/shared/model/enumerations/gestation.model';
import { DeliveryType } from 'app/shared/model/enumerations/delivery-type.model';

export interface IBirthHistory {
  id?: string;
  gestation?: keyof typeof Gestation | null;
  delivery?: keyof typeof DeliveryType | null;
  birthWeight?: number;
  birthHeight?: number;
  breastFed?: boolean;
  twins?: boolean;
  birthOrder?: number;
  notes?: string | null;
  active?: boolean;
  draft?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  pregnancy?: IPregnancyCase | null;
  recordedBy?: IDoctor | null;
  recordedAt?: IHospital | null;
  vitals?: IVitals | null;
  patient?: IGlucoUser | null;
  mother?: IGlucoUser | null;
  father?: IGlucoUser | null;
}

export const defaultValue: Readonly<IBirthHistory> = {
  breastFed: false,
  twins: false,
  active: false,
  draft: false,
};
